import React, { useEffect, useRef, useState } from 'react';
import bgVideo from '/assets/videos/Travel Advertise with us-08.avif';
import arrow from '/assets/arrow.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const AdvertiseSection = () => {
    const [videoStatus, setVideoStatus] = useState('loading');
    const [isMobileFormOpen, setIsMobileFormOpen] = useState(false);
    const [isInterestOpen, setIsInterestOpen] = useState(false);
    const [selectedInterests, setSelectedInterests] = useState([]);
    const interestDropdownRef = useRef(null);

    const interestsList = [
        "Brand Story Features",
        "Sponsored Content",
        "Social Media Campaigns",
        "Web Stories",
        "Destination Campaigns",
        "Banner Placements",
        "Custom Campaign"
    ];

    const toggleInterest = (interest) => {
        setSelectedInterests(prev =>
            prev.includes(interest)
                ? prev.filter(i => i !== interest)
                : [...prev, interest]
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const name = formData.get('name') || 'Not provided';
        const brandName = formData.get('brandName') || 'Not provided';
        const phoneNumber = formData.get('phoneNumber') || 'Not provided';
        const emailAddress = formData.get('emailAddress') || 'Not provided';
        const website = formData.get('website') || 'Not provided';
        const message = formData.get('message') || 'Not provided';
        const interests = selectedInterests.length > 0 ? selectedInterests.join(', ') : 'Not provided';

        const whatsappMessage = `Hi Travel Rethink Ways %0A%0AI'm interested in exploring partnership opportunities with your platform.%0A%0AName: ${name}%0ABrand Name: ${brandName}%0APhone: ${phoneNumber}%0AEmail: ${emailAddress}%0AWebsite / Social Profile: ${website}%0ACollaboration Interest: ${interests}%0AMessage: ${message}`;

        window.open(`https://wa.me/918438506813?text=${whatsappMessage}`, '_blank', 'noopener,noreferrer');
    };

    const handleWhatsAppClick = () => {
        window.open(
            'https://wa.me/918438506813?text=Hi%20Travel%20Rethink%20Ways%0A%0AI%27m%20interested%20in%20exploring%20partnership%20opportunities%20with%20your%20platform.',
            '_blank',
            'noopener,noreferrer'
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (interestDropdownRef.current && !interestDropdownRef.current.contains(event.target)) {
                setIsInterestOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isMobileFormOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isMobileFormOpen]);

    return (
        /* FIX: Used calc(100dvh-76px) for mobile to account for header, rest unchanged */
        <section className={`relative w-full h-[calc(100dvh-76px)] lg:h-auto lg:min-h-[650px] 2xl:min-h-0 2xl:h-[680px] bg-black overflow-hidden flex items-center ${isMobileFormOpen ? 'z-[99999]' : 'z-10'}`}>

            <div className="absolute inset-0 w-full h-full z-0">
                <img
                    src={bgVideo}
                    alt="Travel background"
                    className="absolute inset-0 w-full h-full object-cover object-top lg:object-[50%_calc(65%+25px)] opacity-80 xl:opacity-100 scale-x-[1]"
                    onLoad={() => setVideoStatus('loaded')}
                    onError={() => setVideoStatus('error')}
                />
                <div className="absolute inset-0 bg-black/40 lg:bg-black/10 2xl:bg-transparent pointer-events-none"></div>
            </div>

            <div className="hero-container relative z-10 max-w-[1500px] mx-auto w-full px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-0 flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 lg:gap-6 xl:gap-12 2xl:gap-16 pt-4 lg:pt-0">

                <div className="w-full lg:flex-1 text-white lg:w-1/2 lg:max-w-[50%] xl:max-w-[55%] flex flex-col justify-center items-center lg:items-start text-center lg:text-left mt-0 lg:mt-0 relative lg:-top-[-80px]">

                    <h1 className="text-[36px] sm:text-5xl lg:text-[38px] xl:text-6xl 2xl:text-7xl font-medium mb-4 sm:mb-5 leading-[1.15] font-yeseva">
                        <span className="block lg:inline">India’s Next-Gen</span>{" "}
                        <span className="block lg:inline lg:whitespace-nowrap">Travel &amp; Tourism</span>{" "}
                        <span className="block lg:whitespace-nowrap">Marketing Platform</span>
                    </h1>

                    <p className="text-base sm:text-lg lg:text-[17px] xl:text-xl 2xl:text-[24px] text-gray-100 2xl:text-white leading-[1.6] lg:leading-snug xl:leading-[35px] mb-6 sm:mb-8 lg:mb-4 xl:mb-8 font-poppins max-w-2xl lg:max-w-none">
                        Connect with modern travelers through storytelling, destination discovery, editorial experiences, and multi touch travel influence designed for the discover era.
                    </p>

                    <div className="flex flex-row flex-wrap items-center justify-center lg:justify-start gap-3 sm:gap-4 w-full">
                        <button
                            type="button"
                            onClick={handleWhatsAppClick}
                            className="inline-flex items-center justify-center gap-2 sm:gap-2 w-auto 2xl:w-[175px] h-[44px] lg:h-[40px] xl:h-[44px] 2xl:h-[50px] px-5 2xl:px-6 bg-[#15803d] hover:bg-[#15803d] transition-colors text-white text-[14px] font-poppins font-semibold rounded-[30px] whitespace-nowrap shadow-lg"
                        >
                            <FontAwesomeIcon icon={faWhatsapp} className="text-white w-[24px] h-[24px] sm:w-[28px] sm:h-[28px] lg:w-[20px] lg:h-[20px] xl:w-[24px] xl:h-[24px] 2xl:w-[24px] 2xl:h-[24px]" aria-hidden="true" />
                            <span className="text-[16px] sm:text-[17px] lg:text-[15px] xl:text-[17px] 2xl:text-[18px] font-bold">Starts Here</span>
                        </button>

                        <button
                            type="button"
                            onClick={() => setIsMobileFormOpen(true)}
                            className="lg:hidden inline-flex items-center justify-center gap-2 sm:gap-2 w-auto h-[44px] px-6 bg-[#d02525] hover:bg-[#a61c1c] transition-colors text-white text-[14px] font-poppins font-semibold rounded-[30px] whitespace-nowrap shadow-lg"
                        >
                            <span className="text-[16px] sm:text-[17px] font-bold">Enquire Now</span>
                        </button>
                    </div>
                </div>

                <div className={`w-full flex justify-center lg:justify-end lg:flex-1 lg:w-1/2 lg:max-w-[380px] xl:max-w-[480px] lg:mt-0 ${isMobileFormOpen ? 'fixed inset-0 z-[100] bg-black/80 backdrop-blur-md items-center justify-center p-4' : 'hidden lg:flex'}`}>

                    {isMobileFormOpen && (
                        <button
                            type="button"
                            onClick={() => setIsMobileFormOpen(false)}
                            className="lg:hidden absolute top-4 right-5 sm:top-6 sm:right-8 text-white hover:text-gray-300 text-4xl leading-none font-light z-[200]"
                        >
                            &times;
                        </button>
                    )}

                    <div className="bg-white p-6 sm:p-10 lg:p-5 xl:p-6 rounded-[20px] w-full max-w-md md:max-w-lg lg:max-w-none relative shadow-2xl max-h-[85dvh] overflow-y-auto lg:overflow-visible lg:max-h-none">
                        <h2 className="text-[22px] sm:text-3xl lg:text-xl xl:text-3xl 2xl:text-2xl font-bold text-[#d02525] mb-6 sm:mb-8 lg:mb-4 xl:mb-8 text-center font-yeseva mt-2 lg:mt-0">
                            Reach the Next-Gen Travelers
                        </h2>
                        <form className="space-y-4 sm:space-y-5 lg:space-y-3 xl:space-y-5" onSubmit={handleSubmit}>
                            <input name="name" type="text" placeholder="Your Name" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 lg:py-1.5 xl:py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-base" required />
                            <input name="brandName" type="text" placeholder="Brand Name" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 lg:py-1.5 xl:py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-base" required />
                            <input name="phoneNumber" type="tel" placeholder="Phone Number" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 lg:py-1.5 xl:py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-base" required />
                            <input name="emailAddress" type="email" placeholder="Email Address" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 lg:py-1.5 xl:py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-base" required />
                            <input name="website" type="text" placeholder="Website / Social Profile" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 lg:py-1.5 xl:py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-base" />
                            <div className="relative" ref={interestDropdownRef}>
                                <button type="button" className="w-full bg-transparent border-0 border-b border-gray-300 px-1 py-2 lg:py-1.5 xl:py-2 cursor-pointer flex justify-between items-center text-base transition-colors" onClick={() => setIsInterestOpen(!isInterestOpen)}>
                                    <span className={selectedInterests.length > 0 ? "text-gray-800 truncate pr-4" : "text-gray-500"}>
                                        {selectedInterests.length > 0 ? selectedInterests.join(', ') : "Collaboration Interest"}
                                    </span>
                                </button>
                                {isInterestOpen && (
                                    <div className="absolute z-50 top-full left-0 right-0 mt-1 bg-white border border-gray-100 shadow-xl rounded-md overflow-hidden py-2 max-h-48 overflow-y-auto">
                                        {interestsList.map((interest) => (
                                            <label key={interest} className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer">
                                                <input type="checkbox" className="mr-3 w-4 h-4 text-[#D02525] border-gray-300 rounded" checked={selectedInterests.includes(interest)} onChange={() => toggleInterest(interest)} />
                                                <span className="text-sm text-gray-900">{interest}</span>
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <textarea name="message" placeholder="Message" rows="1" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 lg:py-1.5 xl:py-2 mt-2 resize-none text-base"></textarea>
                            <button type="submit" className="w-full bg-[#d02525] text-white font-black uppercase py-3.5 mt-4 rounded-md shadow-md hover:bg-[#d02525] transition-colors">Start Your Campaign</button>
                            <p className="text-[12px] text-gray-500 text-center leading-relaxed px-1 mt-4">We collaborate with selected Travel & Tourism brands aligned with our ecosystem.</p>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(AdvertiseSection);